import { v1ApiClient } from '@/services';

import type { SharedLink } from './types';

// GetSharedLink
type GetSharedLinkParams = { linkId: string };
type GetSharedLinkResponse = SharedLink;
type GetSharedLinkFunction = (
  params: GetSharedLinkParams,
) => Promise<GetSharedLinkResponse>;

export const getSharedLink: GetSharedLinkFunction = ({ linkId }) =>
  v1ApiClient.get(`/shared-link/${linkId}`).then((res) => res.data);

// GetSharedLinkPublic
type GetSharedLinkPublicParams = { linkId: string; password?: string };
type GetSharedLinkPublicResponse = { link: string };
type GetSharedLinkPublicFunction = (
  params: GetSharedLinkPublicParams,
) => Promise<GetSharedLinkPublicResponse>;

export const getSharedLinkPublic: GetSharedLinkPublicFunction = ({
  linkId,
  password,
}) =>
  v1ApiClient
    .get(`/shared-link/${linkId}/public`, { params: { password } })
    .then((res) => res.data);
